import { ProductBundleOption, ProductOption, ProductOptionData } from "@/product-options/option.base";
import { VlaicuOption } from "@/product-options/option.vlaicu";
import { Product, ProductData, UnboundProductOptionData } from "@/products/product.base";
import { Constants } from "@repobit/dex-constants";

export class VlaicuProduct extends Product {
  constructor(product: ProductData) {
    super(product);
  }

  protected _createOption(product: ProductOptionData): ProductOption {
    return new VlaicuOption(product);
  }

  protected async bundle(
    base: ProductOption,
    options: ProductBundleOption[]
  ): Promise<UnboundProductOptionData> {
    // Get the base bundle from common logic.
    const bundleOption = await super.bundle(base, options);

    const baseUrl = this.getBuyLinkBaseUrl();
    if (baseUrl) {
      const provider = baseUrl.includes(Constants.CHECKOUT_LINK_PATH)
        ? Constants.CHECKOUT_PROVIDER
        : Constants.ZUORA_PROVIDER;
      const bundleURL = new URL(baseUrl);
      const allOptionsInBundle = [base, ...options.map(bundleOption => bundleOption.option)];
      switch (provider) {
        case Constants.CHECKOUT_PROVIDER: {
          const bundlesData = allOptionsInBundle
            .reduce((acc: { [key: string]: (string | number)[] }, bundle) => {
              acc['COUPON'] = (acc['COUPON'] || []).concat([bundle.getCoupon() || ''].filter(Boolean));
              acc['PRODS'] = (acc['PRODS'] || []).concat([bundle.getVerifoneProductId() || '']);
              acc['QTY'] = (acc['QTY'] || []).concat([1]);
              acc[`OPTIONS${bundle.getVerifoneProductId()}`] = [bundle.getVerifoneOptionCode() || ''];
              return acc;
            }, {});

          Object.entries(bundlesData).forEach(([key, value]) => {
            if (value.length) {
              bundleURL.searchParams.set(key, value.join(','))
            }
          });
          break;
        }
        default: {
          const [baseOption, ...bundleOptions] = allOptionsInBundle;
          bundleURL.searchParams.append('campaign', baseOption.getProduct().getCampaign() || '');
          bundleURL.searchParams.append('product_id', baseOption.getProduct().getId());
          bundleURL.searchParams.append('payment_period', baseOption.getCheckoutPaymentPeriod() || '');

          bundleOptions.forEach(bundleOption => {
            bundleURL.searchParams.append('bundle_id', bundleOption.getProduct().getId());
            bundleURL.searchParams.append('bundle_payment_period', bundleOption.getCheckoutPaymentPeriod() || '');
          });
          break;
        }
      }

      bundleOption.buyLink = bundleURL.href;
    }

    return bundleOption;
  }
}